<template>
  <div class="store-page pk-account-panel">
    <section class="store-hero">
      <div>
        <span>饰品商城</span>
        <h1>饰品商城</h1>
        <p>选择你想要的饰品，加入购物车后使用账户披萨币购买。商品、价格和可用状态以页面展示为准。</p>
      </div>
      <div class="hero-balance">
        <span>可用余额</span>
        <strong>{{ moneyText($store.state.money) }} <i></i></strong>
      </div>
    </section>

    <section class="market-toolbar">
      <div class="type-strip">
        <button
          v-for="item in selList"
          :key="item.id"
          :class="{ active: item.id === classId }"
          @click="selOran(item.status, item.id)"
        >
          <img :src="item.img || defaultTypeImg" alt="" @error="setImageFallback($event, defaultTypeImg)" />
          <span>{{ marketLabel(item.name) }}</span>
        </button>
      </div>

      <div v-if="classList.length" class="subclass-strip">
        <button
          v-for="item in classList"
          :key="item.id"
          :class="{ active: item.id === subClassId }"
          @click="setSubClassId(item)"
        >
          {{ marketLabel(item.name) }}
        </button>
      </div>

      <div class="market-actions">
        <button class="sort-btn" @click="listSort">{{ priceSort ? "价格从低到高" : "价格从高到低" }}</button>
        <el-input
          v-model="searchKey"
          class="market-search"
          placeholder="按名称搜索"
          @keyup.enter.native="getList(1)"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" @click="getList(1)"></i>
        </el-input>
      </div>
    </section>

    <section class="skin-grid">
      <article
        v-for="item in list"
        :key="item.id"
        class="skin-card"
        :class="{ selected: item.state }"
        @click="buyState(item.id)"
      >
        <em v-if="item.exteriorName">{{ item.exteriorName }}</em>
        <span v-if="item.state" class="selected-mark">✓</span>
        <div class="skin-visual">
          <img :src="item.imageUrl || defaultSkinImg" alt="" @error="setImageFallback($event, defaultSkinImg)" />
        </div>
        <strong :title="item.itemName">{{ item.itemName }}</strong>
        <div class="skin-meta">
          <span>{{ moneyText(item.price) }} <i></i></span>
          <b>库存 {{ item.stock }}</b>
        </div>
      </article>
    </section>

    <div v-if="!list.length" class="empty-card">暂无商品，调整分类或关键词后再试。</div>

    <el-pagination
      v-if="totalSize > pageSize"
      class="store-page-nav"
      background
      layout="prev, pager, next"
      :total="totalSize"
      :page-size="pageSize"
      @current-change="currentChange"
    ></el-pagination>

    <section v-if="total_num" class="cart-bar">
      <div>
        <span>已选择 {{ total_num }} 件</span>
        <strong>{{ total_price }} <i></i></strong>
      </div>
      <button @click="showSure = true">购买</button>
      <button class="muted" @click="offAll">清空</button>
    </section>

    <div class="buy-sure" v-if="showSure">
      <div class="sure">
        <strong>确认购买？</strong>
        <p>将使用账户披萨币购买已选饰品，确认后请以页面提示和账户账单记录为准。</p>
        <div class="btns">
          <button class="muted" @click="showSure = false">取消</button>
          <button @click="goBuy">确认</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "./../assets/js/util.js";
import { playUiSound } from "@/utils/pizzaSound";

export default {
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    return {
      loading: false,
      totalSize: 0,
      page: 1,
      pageSize: 24,
      list: [],
      buyCart: [],
      total_num: 0,
      total_price: 0,
      priceSort: true,
      searchKey: "",
      classId: "",
      subClassId: "all",
      recommend: 1,
      classList: [],
      selList: [],
      showSure: false,
      defaultTypeImg: require("../assets/hotpizza/hp-case-purple-transparent.png"),
      defaultSkinImg: require("../assets/hotpizza/hp-ak-green.png"),
      skinImageCache: {
        468: require("../assets/skin-cache/roll-468.png"),
        679: require("../assets/skin-cache/roll-679.png"),
        1227: require("../assets/skin-cache/roll-1227.png"),
        874: require("../assets/skin-cache/roll-874.png"),
        747: require("../assets/skin-cache/roll-747.png"),
        1229: require("../assets/skin-cache/roll-1229.png"),
        1242: require("../assets/skin-cache/roll-1242.png"),
        1599: require("../assets/skin-cache/roll-1599.png"),
        435: require("../assets/skin-cache/roll-435.png"),
        1372: require("../assets/skin-cache/roll-1372.png"),
        677: require("../assets/skin-cache/roll-677.png"),
        730: require("../assets/skin-cache/roll-730.png"),
        744: require("../assets/skin-cache/roll-744.png"),
        509: require("../assets/skin-cache/roll-509.png"),
        1111: require("../assets/skin-cache/roll-1111.png"),
        1536: require("../assets/skin-cache/roll-1536.png"),
        959: require("../assets/skin-cache/roll-959.png"),
        875: require("../assets/skin-cache/roll-875.png"),
        680: require("../assets/skin-cache/roll-680.png"),
        1249: require("../assets/skin-cache/roll-1249.png"),
        673: require("../assets/skin-cache/roll-673.png"),
        869: require("../assets/skin-cache/roll-869.png"),
        1530: require("../assets/skin-cache/roll-1530.png"),
        1771: require("../assets/skin-cache/roll-1771.png"),
      },
    };
  },
  watch: {
    searchKey(value) {
      if (value.length === 0) {
        this.getList(1);
      }
    },
    classId(value) {
      if (!value) return;
      this.classList = [{ name: "全部", id: "all" }];
      this.subClassId = "all";
      this.$axios.post("/index/Lucky/subclassList", this.$qs.stringify({ type_id: value })).then((res) => {
        if (res.data.status && res.data.data && res.data.data.list) {
          this.classList.push(...res.data.data.list);
        }
      });
    },
  },
  mounted() {
    this.getListClass();
    this.getList(this.page);
  },
  methods: {
    setSubClassId(item) {
      this.subClassId = item.id;
      this.getList(1);
    },
    selOran(status, id) {
      this.recommend = status == 2 ? 1 : 2;
      this.classId = id;
      this.getList(1);
    },
    getListClass() {
      this.$axios.post("/index/Lucky/luckyTypeList").then((res) => {
        if (res.data.status == 1) {
          this.selList = res.data.data;
          for (let i = 0; i < this.selList.length; i++) {
            this.selList[i].img = this.stableImage(this.selList[i].img, this.defaultTypeImg);
          }
          this.classId = this.selList[0].id;
        }
      });
    },
    currentChange(val) {
      this.getList(val);
    },
    getList(val) {
      this.page = val || 1;
      const param = {
        page: this.page,
        pageSize: this.pageSize,
        order: this.priceSort ? "asc" : "desc",
      };
      if (this.searchKey) {
        param.searchKey = this.searchKey;
      }
      if (this.classId && this.classId != "all") {
        param.type_id = this.classId;
      }
      if (this.subClassId && this.subClassId != "all") {
        param.subclass_id = this.subClassId;
      }
      if (this.classId == "1") {
        param.recommend = 1;
        delete param.type_id;
      }

      this.$axios.post("index/Store/skinList", this.$qs.stringify(param)).then((res) => {
        if (res.data.status == 1) {
          this.totalSize = res.data.data.total;
          this.list = res.data.data.list;
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].imageUrl = this.skinImageCache[this.list[i].id] || this.stableImage(this.list[i].imageUrl, this.defaultSkinImg);
            this.list[i].state = this.buyCart.some((cart) => cart.id == this.list[i].id);
          }
        }
      });
    },
    offAll() {
      this.buyCart = [];
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].state = false;
      }
      this.buyNum();
    },
    buyState(id) {
      for (let i = 0; i < this.list.length; i++) {
        if (id == this.list[i].id) {
          this.list[i].state = !this.list[i].state;
          if (this.list[i].state) {
            const one = Object.assign({ num: 1 }, this.list[i]);
            this.buyCart.push(one);
          } else {
            this.buyCart = this.buyCart.filter((item) => item.id != id);
          }
        }
      }
      this.buyNum();
      this.$forceUpdate();
    },
    buyNum() {
      this.total_num = 0;
      this.total_price = 0;
      for (let i = 0; i < this.buyCart.length; i++) {
        this.total_num += this.buyCart[i].num;
        this.total_price += Number(this.buyCart[i].price) * this.buyCart[i].num;
      }
      this.total_price = this.total_price.toFixed(2);
    },
    goBuy() {
      this.loading = true;
      this.$axios.post("index/Store/buynew", this.$qs.stringify({ skin_info: this.buyCart })).then((res) => {
        if (res.data.status == 1) {
          this.loading = false;
          this.buyCart = [];
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].state = false;
          }
          this.total_num = 0;
          this.total_price = 0;
          this.$store.commit("getMoney", res.data.data.total_amount);
          Utils.$emit("masonry", res.data.data.total_amount);
          this.$message({ message: res.data.msg, type: "success" });
          playUiSound("purchase");
          this.showSure = false;
        } else {
          this.loading = false;
          this.showSure = false;
          this.$message({ message: res.data.msg || "购买失败", type: "warning" });
        }
      });
    },
    listSort() {
      this.priceSort = !this.priceSort;
      this.getList(1);
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    marketLabel(value) {
      const labels = {
        "recommended accessories": "推荐饰品",
        dagger: "匕首",
        gloves: "手套",
        rifle: "步枪",
        "micro submachine gun": "冲锋枪",
        pistol: "手枪",
        "sniper rifle": "狙击步枪",
      };
      const key = String(value || "").trim().toLowerCase();
      return labels[key] || value;
    },
    stableImage(value, fallback) {
      if (!value) return fallback;
      if (value.indexOf("http://") === 0) return fallback;
      if (value.indexOf("https://img.zbt.com") === 0) return fallback;
      if (value.indexOf("csgoapi.akaifa998.icu") !== -1) return fallback;
      if (value.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1) return fallback;
      return value;
    },
    setImageFallback(event, fallback) {
      event.target.src = fallback;
    },
  },
};
</script>

<style lang="less" scoped>
.store-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 110px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 42% 0, rgba(255, 138, 31, 0.17), transparent 30%),
    radial-gradient(circle at 82% 26%, rgba(111, 79, 255, 0.12), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.store-hero,
.market-toolbar,
.skin-grid,
.empty-card,
.store-page-nav {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.store-hero {
  min-height: 278px;
  padding: 42px 50px;
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 24px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.store-hero::after {
  content: "";
  width: 720px;
  height: 260px;
  position: absolute;
  right: -130px;
  bottom: -150px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 138, 0, 0.38), transparent 66%);
}

.store-hero > div {
  position: relative;
  z-index: 1;
}

.store-hero span,
.hero-balance span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.store-hero h1 {
  margin: 12px 0 14px;
  font-size: 62px;
  line-height: 0.98;
  font-weight: 1000;
}

.store-hero p {
  max-width: 690px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
  font-weight: 800;
}

.hero-balance {
  min-height: 142px;
  padding: 24px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.075);
}

.hero-balance strong {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ffd764;
  font-size: 34px;
  font-weight: 1000;
}

.hero-balance i,
.skin-meta i,
.cart-bar i {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.market-toolbar {
  margin-top: 22px;
  padding: 18px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 18px 54px rgba(0, 0, 0, 0.22);
}

.type-strip,
.subclass-strip,
.market-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.type-strip button {
  min-width: 120px;
  height: 82px;
  padding: 8px 12px;
  color: #9ea7ba;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 9px;
  font-weight: 1000;
}

.type-strip img {
  max-width: 70px;
  height: 40px;
  display: block;
  margin: 0 auto 6px;
  object-fit: contain;
}

.type-strip button.active,
.subclass-strip button.active {
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border-color: transparent;
}

.subclass-strip {
  margin-top: 12px;
}

.subclass-strip button,
.sort-btn {
  height: 38px;
  padding: 0 16px;
  color: #f4f6ff;
  background: #292c3a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.market-actions {
  margin-top: 16px;
  align-items: center;
  justify-content: space-between;
}

.sort-btn {
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
}

.market-search {
  width: 360px;
}

.market-search /deep/ .el-input__inner {
  color: #f4f6ff;
  background: #1b1d28;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.skin-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));
  gap: 12px;
}

.skin-card {
  min-height: 232px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  background: linear-gradient(180deg, #2b2e3d, #242735);
  border: 1px solid rgba(255, 255, 255, 0.055);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.skin-card:hover,
.skin-card.selected {
  transform: translateY(-2px);
  border-color: rgba(255, 138, 0, 0.5);
  box-shadow: 0 20px 44px rgba(0, 0, 0, 0.26), 0 0 28px rgba(255, 138, 0, 0.13);
}

.skin-card em {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 2;
  padding: 3px 8px;
  color: #ffce70;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 99px;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
}

.selected-mark {
  width: 28px;
  height: 28px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 2;
  display: grid;
  place-items: center;
  color: #151620;
  background: #ffb11f;
  border-radius: 50%;
  font-weight: 1000;
}

.skin-visual {
  height: 132px;
  display: grid;
  place-items: center;
  position: relative;
}

.skin-visual::before {
  content: "";
  width: 150px;
  height: 98px;
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(120, 72, 255, 0.28), transparent 68%);
}

.skin-visual img {
  max-width: 150px;
  max-height: 102px;
  position: relative;
  object-fit: contain;
  filter: drop-shadow(0 16px 20px rgba(0, 0, 0, 0.46));
}

.skin-card strong {
  min-height: 38px;
  display: block;
  overflow: hidden;
  color: #f5f7ff;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 1000;
}

.skin-meta {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.skin-meta span {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #ffd764;
  font-size: 16px;
  font-weight: 1000;
}

.skin-meta b {
  color: #8f98ab;
  font-size: 12px;
}

.empty-card {
  margin-top: 18px;
  padding: 34px 18px;
  color: #929bad;
  text-align: center;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
}

.store-page-nav {
  margin-top: 18px;
  text-align: right;
}

.store-page-nav /deep/ .el-pager li:not(.disabled).active {
  color: #151620;
  background: #ffae1d;
}

.store-page-nav /deep/ .el-pagination.is-background .btn-next,
.store-page-nav /deep/ .el-pagination.is-background .btn-prev,
.store-page-nav /deep/ .el-pagination.is-background .el-pager li {
  color: #aab3c6;
  background: #242735;
}

.cart-bar {
  width: min(720px, calc(100% - 32px));
  min-height: 66px;
  padding: 10px 12px 10px 22px;
  position: fixed;
  left: 50%;
  bottom: 22px;
  z-index: 80;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #f6f8ff;
  background: rgba(32, 34, 47, 0.96);
  border: 1px solid rgba(255, 138, 0, 0.35);
  border-radius: 12px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.38);
}

.cart-bar span {
  color: #9da6ba;
  font-size: 13px;
  font-weight: 900;
}

.cart-bar strong {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffd764;
  font-size: 23px;
  font-weight: 1000;
}

.cart-bar button,
.buy-sure button {
  height: 42px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
}

.cart-bar .muted,
.buy-sure .muted {
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.buy-sure {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, 0.62);
}

.sure {
  width: min(420px, calc(100% - 32px));
  padding: 26px;
  color: #f4f6ff;
  background: #252836;
  border: 1px solid rgba(255, 138, 0, 0.28);
  border-radius: 14px;
  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.45);
}

.sure strong {
  font-size: 24px;
  font-weight: 1000;
}

.sure p {
  color: #9fa8bb;
  line-height: 1.7;
}

.btns {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media screen and (max-width: 980px) {
  .store-page {
    padding: 20px 12px 110px;
  }

  .store-hero {
    grid-template-columns: 1fr;
    padding: 34px 24px;
  }

  .store-hero h1 {
    font-size: 46px;
  }

  .market-search {
    width: 100%;
  }
}
</style>

<style lang="less">
.store-page.pk-account-panel {
  padding: 32px 28px 120px !important;
}

.store-page.pk-account-panel .store-hero,
.store-page.pk-account-panel .market-toolbar,
.store-page.pk-account-panel .skin-grid,
.store-page.pk-account-panel .empty-card,
.store-page.pk-account-panel .store-page-nav {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.store-page.pk-account-panel .store-hero {
  min-height: 318px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.store-page.pk-account-panel .hero-balance {
  min-height: 174px !important;
  border-color: rgba(111, 121, 151, 0.24) !important;
  background:
    radial-gradient(ellipse at 50% 70%, rgba(255, 132, 31, 0.16), transparent 62%),
    rgba(255, 255, 255, 0.045) !important;
}

.store-page.pk-account-panel .skin-grid {
  grid-template-columns: repeat(auto-fill, minmax(206px, 1fr)) !important;
  gap: 14px !important;
}

.store-page.pk-account-panel .skin-card {
  min-height: 264px !important;
  border-color: rgba(111, 121, 151, 0.18) !important;
}

.store-page.pk-account-panel .skin-visual {
  height: 156px !important;
}

.store-page.pk-account-panel .skin-visual::before {
  width: 176px !important;
  height: 112px !important;
  background: radial-gradient(circle, rgba(255, 132, 31, 0.14), rgba(120, 72, 255, 0.28), transparent 68%) !important;
}

.store-page.pk-account-panel .skin-visual img {
  max-width: 178px !important;
  max-height: 120px !important;
}

.store-page.pk-account-panel .cart-bar {
  width: min(820px, calc(100% - 56px)) !important;
  border-color: rgba(255, 138, 0, 0.46) !important;
}

@media screen and (max-width: 980px) {
  .store-page.pk-account-panel {
    padding: 18px 12px 110px !important;
  }

  .store-page.pk-account-panel .store-hero,
  .store-page.pk-account-panel .market-toolbar,
  .store-page.pk-account-panel .skin-grid,
  .store-page.pk-account-panel .empty-card,
  .store-page.pk-account-panel .store-page-nav {
    width: 100% !important;
  }

  .store-page.pk-account-panel .skin-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

/* 2026-07-05 exact internal pass: store/roll marketplace. */
.store-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 120px !important;
  background:
    radial-gradient(ellipse at 50% 170px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

.store-page.pk-account-panel .store-hero,
.store-page.pk-account-panel .market-toolbar,
.store-page.pk-account-panel .skin-grid,
.store-page.pk-account-panel .empty-card,
.store-page.pk-account-panel .store-page-nav {
  width: 100% !important;
  max-width: none !important;
}

.store-page.pk-account-panel .store-hero {
  min-height: 276px !important;
  padding: 30px 38px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 74% 52%, rgba(255, 138, 31, 0.14), transparent 48%),
    #20222f !important;
  box-shadow: none !important;
}

.store-page.pk-account-panel .hero-copy h1 {
  color: #f4ead8 !important;
  font-size: 52px !important;
}

.store-page.pk-account-panel .market-toolbar {
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
}

.store-page.pk-account-panel .skin-grid {
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)) !important;
  gap: 10px !important;
}

.store-page.pk-account-panel .skin-card {
  min-height: 240px !important;
  border: 1px solid rgba(67, 73, 96, 0.68) !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 50% 36%, rgba(128, 72, 255, 0.22), transparent 54%),
    #252837 !important;
}

.store-page.pk-account-panel .skin-visual {
  height: 132px !important;
}

.store-page.pk-account-panel .skin-visual img {
  max-width: 156px !important;
  max-height: 104px !important;
}
</style>
